import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useIdempotentAppMutation } from '../use-idempotent-app-mutation.hook';

export const useDelete = () => {
  const { mutate: deleteShareClass, isPending } = useIdempotentAppMutation(
    [QueryKey.DELETE_SHARE_CLASS],
    {
      mutationFn: (
        { companyId, shareClassId }: { companyId: string; shareClassId: string },
        { headers },
      ) =>
        ApiService.delete(
          {
            endpoint: BackendRoute.COMPANIES,
            routePath: [companyId, 'share-classes', shareClassId],
          },
          { headers },
        ),
    },
  );
  return { deleteShareClass, isPending };
};
